import { createSelector } from 'reselect'
import isBlackFridayOrCyberMondayBFCMSelect from 'modules/black-friday-cyber-monday/redux/selectors/is-black-friday-or-cyber-monday'
import isHolidayGiftsSelect from 'modules/holiday-gifts/redux/selectors/is-holiday-gifts'
import isFeaturedDealsSelect from 'modules/featured-deals/redux/selectors/is-featured'
import isSpringDealsSelect from 'modules/spring-deals/redux/selectors/is-spring-deal'

const hasOngoingDealsAppSelect = createSelector(
  isBlackFridayOrCyberMondayBFCMSelect,
  isHolidayGiftsSelect,
  isFeaturedDealsSelect,
  isSpringDealsSelect,
  (
    isBlackFridayOrCyberMonday,
    isHolidayGifts,
    isFeaturedDeals,
    isSpringDeals
  ) => {
    return (
      isBlackFridayOrCyberMonday ||
      isHolidayGifts ||
      isFeaturedDeals ||
      isSpringDeals
    )
  }
)

export default hasOngoingDealsAppSelect
